export { default as adminLocaleEn } from './localeEn';
export { default as adminLocaleEs } from './localeEs';
export { default as adminLocalePt } from './localePt';
